import { SVGProps, Ref, forwardRef } from 'react';

export const Diagram80Size16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2.533a5.467 5.467 0 1 1-4.734 2.734l-1.04-.6A6.667 6.667 0 1 0 8 1.333z"
                fill="currentColor"
            />
        </g>
    </svg>
));
Diagram80Size16Glyph.displayName = 'Diagram80Size16Glyph';
